import api from '@/api';
import { cache } from '@/components/MiningAndPumping/cache';
import { normalizeData } from '@/utils';
import { message } from 'antd';

export const defaultActiveVersions = [0];

// TODO: this model not be here! Because is global entity.
const versions = {
    name: 'versions',
    state: {
        data: {},
        active: [],
    },

    reducers: {
        setVersions(state, payload) {
            return { ...state, data: payload };
        },
        setActiveVersions(state, payload) {
            return { ...state, active: payload };
        },
    },

    effects: dispatch => ({
        startLoading(mode) {
            if (mode === 'miningAndPumping') {
                dispatch.chartsWidget.setLoadingDataChart(true);
                dispatch.tableWidget.setLoadingDataSource(true);
            }
        },

        endLoading(mode) {
            if (mode === 'miningAndPumping') {
                dispatch.chartsWidget.setLoadingDataChart(false);
                dispatch.tableWidget.setLoadingDataSource(false);
            }
        },

        resetVersionsToDefault() {
            this.setVersions({});
            this.setActiveVersions([]);
        },

        initializeVersions({ data = [], active = defaultActiveVersions }) {
            const normalizedData = normalizeData(data).data;

            this.setVersions(normalizedData);
            this.setActiveVersions(active);
        },

        async fetchAll(payload) {
            const { params, mode } = payload;
            this.startLoading(mode);
            try {
                const versionsFromApi = await cache.getData(params, api.gtmEfficiency.fetchVersions);
                if (!versionsFromApi.length) {
                    await this.resetVersionsToDefault();

                    message.info('Для данного объекта отсутствуют версии технологических показателей');
                } else {

                    await this.initializeVersions({ data: versionsFromApi, active: defaultActiveVersions });
                }
            } catch (error) {
                message.error('Не удалось получить список версий для технологических показателей');
                this.endLoading(mode);
                console.error(error);
            }
        },
        async fetchForWell(payload) {
            const { id, mode = null } = payload;
            this.startLoading(mode);
            try {
                const versionsFromApi = await cache.getData({ id }, api.miningAndPumping.fetchVersionsForWell);
                if (!versionsFromApi.length) {
                    await this.resetVersionsToDefault();

                    message.info('Для данной скважины отсутствуют версии технологических показателей');
                } else {
                    await this.initializeVersions({ data: versionsFromApi, active: defaultActiveVersions });

                }
            } catch (error) {
                message.error('Не удалось получить список версий для технических показателей');
                this.endLoading(mode);
                console.error(error);
            }
        },
    }),
    selectors: slice => ({
        activeExist() {
            return slice(state => state.active?.length > 0);
        },
    }),
};

export default versions;
